"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxIdsNeedingSubdivision = exports.TaxIds = exports.OrderAction = exports.OrderState = exports.UserType = exports.BillingType = exports.BillingCycle = exports.OrderType = exports.SourceSystem = exports.SellingMotionType = exports.MigrationSellingMotion = exports.PaymentMethod = exports.Region = exports.CloudStorageType = void 0;
var CloudStorageType;
(function (CloudStorageType) {
    CloudStorageType["Amazon"] = "Amazon";
    CloudStorageType["Other"] = "Other";
})(CloudStorageType || (exports.CloudStorageType = CloudStorageType = {}));
var Region;
(function (Region) {
    Region["US"] = "US";
    Region["EU"] = "EU";
})(Region || (exports.Region = Region = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CreditCard"] = "CreditCard";
    PaymentMethod["Invoice"] = "Invoice";
    PaymentMethod["InvoiceNet30"] = "Invoice - Net 30";
    PaymentMethod["InvoiceNet45"] = "Invoice - Net 45";
    PaymentMethod["InvoiceNet60"] = "Invoice - Net 60";
    PaymentMethod["InvoiceNet90"] = "Invoice - Net 90";
    PaymentMethod["Comp"] = "Comp";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
var MigrationSellingMotion;
(function (MigrationSellingMotion) {
    MigrationSellingMotion["EcommBuyNow"] = "eCommerce: Buy Now";
    MigrationSellingMotion["EcommTrialConversion"] = "eCommerce: Free Trial Conversion";
    MigrationSellingMotion["SalesMotionMigrated"] = "Migrated - Sales Motion";
})(MigrationSellingMotion || (exports.MigrationSellingMotion = MigrationSellingMotion = {}));
var SellingMotionType;
(function (SellingMotionType) {
    SellingMotionType["EcommBuyNow"] = "eCommerce: Buy Now";
    SellingMotionType["EcommTrialConversion"] = "eCommerce: Free Trial Conversion";
    SellingMotionType["MigratedChannel"] = "Migrated - Sales Motion - Channel";
    SellingMotionType["MigratedDirect"] = "Migrated - Sales Motion - Direct";
    SellingMotionType["SalesMotionMigrated"] = "Migrated - Sales Motion";
    SellingMotionType["TraditionalSalesMotion"] = "Traditional Sales Motion";
})(SellingMotionType || (exports.SellingMotionType = SellingMotionType = {}));
var SourceSystem;
(function (SourceSystem) {
    SourceSystem["Ecomm"] = "ECOMM";
    SourceSystem["SFDC"] = "SFDC";
})(SourceSystem || (exports.SourceSystem = SourceSystem = {}));
var OrderType;
(function (OrderType) {
    OrderType["TryNow"] = "TryNow";
    OrderType["BuyNow"] = "BuyNow";
    OrderType["FreeTrial"] = "FreeTrial";
    OrderType["Paid"] = "Paid";
    OrderType["TrialConversion"] = "TrialConversion";
    OrderType["Amendment"] = "Amendment";
    OrderType["Migration"] = "Migration";
    OrderType["Reactivation"] = "Reactivation";
    OrderType["EnterpriseMigration"] = "EnterpriseMigration";
})(OrderType || (exports.OrderType = OrderType = {}));
var BillingCycle;
(function (BillingCycle) {
    BillingCycle["Month"] = "Month";
    BillingCycle["Quarter"] = "Quarter";
    BillingCycle["Year"] = "Year";
    BillingCycle["Once"] = "Once";
})(BillingCycle || (exports.BillingCycle = BillingCycle = {}));
var BillingType;
(function (BillingType) {
    BillingType["Comp"] = "Comp";
    BillingType["CreditCard"] = "Credit Card";
    BillingType["CTXS"] = "CTXS";
    BillingType["CTXSOC"] = "CTXSOC";
    BillingType["Free"] = "Free";
    BillingType["Invoice"] = "Invoice";
    BillingType["OSD"] = "OSD";
    BillingType["ServiceProviders"] = "ServiceProviders";
    BillingType["SFHybris"] = "SFHybris";
    BillingType["SMBHybris"] = "Hybris";
})(BillingType || (exports.BillingType = BillingType = {}));
var UserType;
(function (UserType) {
    UserType["MasterAdmin"] = "MasterAdmin";
    UserType["TechnicalContact"] = "TechnicalContact";
    UserType["BillingContact"] = "BillingContact";
})(UserType || (exports.UserType = UserType = {}));
var OrderState;
(function (OrderState) {
    OrderState["Pending"] = "Pending";
    OrderState["Processing"] = "Processing";
    OrderState["Failed"] = "Failed";
    OrderState["Success"] = "Success";
    OrderState["Partial_Success"] = "Partial Success";
    OrderState["Reprocessing"] = "Reprocessing";
})(OrderState || (exports.OrderState = OrderState = {}));
var OrderAction;
(function (OrderAction) {
    OrderAction["TrialConversion"] = "TrialConversion";
    OrderAction["Cancellation"] = "Cancellation";
    OrderAction["Reactivation"] = "Reactivation";
    OrderAction["PlanChange"] = "PlanChange";
    OrderAction["ExpiredTrialConversion"] = "ExpiredTrialConversion";
})(OrderAction || (exports.OrderAction = OrderAction = {}));
var TaxIds;
(function (TaxIds) {
    TaxIds["EuropeanVATID"] = "EuropeanVATID";
    TaxIds["GSTID"] = "GSTID";
    TaxIds["QSTID"] = "QSTID";
    TaxIds["PSTID"] = "PSTID";
    TaxIds["ABN"] = "ABN";
})(TaxIds || (exports.TaxIds = TaxIds = {}));
exports.TaxIdsNeedingSubdivision = [TaxIds.QSTID, TaxIds.PSTID];
//# sourceMappingURL=common.js.map